const accessibilityPropCheck = (props, propName, componentName) => {
  const { accessibility: acc } = props;

  if (!acc.title && !acc['aria-label'] && !acc['aria-labelledby']) {
    const additionalMessage =
      'One of these props must be set: `title`, `aria-label` or `aria-labelledby`';
    return new Error(
      `Invalid prop \`${propName}\` supplied to \`${componentName}\`. Validation failed. ${additionalMessage}`,
    );
  }
};

export default accessibilityPropCheck;
